import { InputRightAddon } from '@chakra-ui/react';
export default InputRightAddon;